<section class="content">
  <div class="container-fluid">
    <form class="register-form1" [formGroup]="formGroupPageName"  (ngSubmit)="onSubmit()" >
      <app-breadcrumb-button-top [titlePage]="title" [showBtnStatus]="false"
      [showBtnAddNew]="false" [showBtnCancel]="false" [showBtnSaveChanges]="false"
      [addOrEditButton]="addOrEditButton" [formGroupPageName]="this.formGroupPageName"
      (eventOnAddEmitter)="onNew()" (eventOnCloseEmitter)="onClose()"></app-breadcrumb-button-top>

      <p-messages [(value)]="message"></p-messages>
      <input formControlName="id" [(ngModel)]="objVersetDuJour.id" type="hidden" />

      <div class="card" style="padding: 10px 10px;">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
            <label for="inputtext">{{bookService.textField.title}}</label>
            <p-dropdown [options]="bookService.bookDataList" [(ngModel)]="objVersetDuJour.bookOsis" formControlName="bookOsis" [itemSize]="10"
                [virtualScroll]="false" [filter]="false" [checkmark]="true" optionValue="osis" optionLabel="human"
                styleClass="w100"  placeholder=" -Select {{textField.bookOsis}} -" [loading]="bookService.loadingDataList"
                [style]="{'width':'100%'}" (onChange)="getChapitreList()">
                <ng-template let-option  pTemplate="selectedItem">
                  <div class="ofa" pTooltip="{{option.osis}}-{{option.human}}" tooltipPosition="bottom">
                    {{option.id}} {{option.osis}} | {{option.human}}
                  </div>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <span> @if(option.osis!=''){[{{option.id}}] : } {{option.human}} </span>
                </ng-template>
            </p-dropdown>
          </div>

          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
            <label for="inputtext">{{bookService.textField.chapters}}</label>
            <p-dropdown [options]="chapitreList" [(ngModel)]="chapitreSelected" formControlName="chapitreSelected" [itemSize]="10"
                [virtualScroll]="false" [filter]="false" [checkmark]="true"
                styleClass="w100"  placeholder=" -Select chapter [{{chapitreList.length}}]-" [loading]="bookService.loadingDataList"
                [style]="{'width':'100%'}" (onChange)="getVersesList()">
            </p-dropdown>
          </div>

          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
            <mat-form-field>
              <mat-label>{{textField.dateDeclancheur}}</mat-label>
              <input matInput [matDatepicker]="picker" [(ngModel)]="objVersetDuJour.dateDeclancheur" formControlName="dateDeclancheur" >
              <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
            <div class="tr">
              <span class="tr badge badgeStatus">
                <label for="actifYN">
                <input type="checkbox" [checked]="objVersetDuJour.actifYN" [(ngModel)]="objVersetDuJour.actifYN"
                  formControlName="actifYN">{{textField.actifYN}}</label>
              </span>
            </div>
          </div>

          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="row">
              @if(versesService.versesDataList && versesService.versesDataList.length<=0){
                {{enumText.NoDatafound}}...
              }
              <input formControlName="verset" [(ngModel)]="objVersetDuJour.verset" type="hidden" />
              @for (item of versesService.versesDataList; track $index) {
                <div class="verseStyle cp {{onSelectedVersesStyle(item.verse)}}" (click)="objVersetDuJour.verset = item.verse">
                  {{item.versetReal}}.- {{item.unformatted}}
                </div>
              }
            </div>
          </div>

        </div>
      </div>

      <app-tools-button-save [showBtnCancel]="true" [addOrEditButton]="addOrEditButton" [formGroupPageName]="this.formGroupPageName"
      (eventOnCloseEmitter)="onClose()"></app-tools-button-save>

    </form>

  </div>
</section>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-toast position="top-center"></p-toast>
